import { ReactNode } from "react";
import ImageCTAMeatball from "./ImageCTAMeatball";

type FeaturedTextBoxProps = {
	accentBarColor?: string;
	eyebrow?: string;
	headline?: string;
	description?: ReactNode;
	linkText?: string;
	linkUrl?: string;
	headlineStyle?: string;
};
const FeaturedTextBox = ({
	accentBarColor,
	eyebrow,
	headline,
	description,
	linkText,
	linkUrl,
	headlineStyle = "t-heading-xl"
}: FeaturedTextBoxProps) => {
	return (
		<div className="featured-text-box">
			{accentBarColor && <div className={`accent-bar-${accentBarColor}`}></div>}
			{eyebrow && (
				<div className="featured-text-box-eyebrow t-label-sm-heavy tc-cool-gray-02">{eyebrow}</div>
			)}
			{headline && <div className={`featured-text-box-headline ${headlineStyle}`}>{headline}</div>}
			{description && <div className="featured-text-box-description t-body-md">{description}</div>}
			{linkText && (
				<a href={linkUrl} className="cta-meatball-link t-body-sm tc-cool-gray-01">
					<div className="cta-meatball-icon">
						<ImageCTAMeatball />
					</div>
					<div className="link-text">{linkText}</div>
				</a>
			)}
		</div>
	);
};
export default FeaturedTextBox;
